@if (data()) {
<div class="container-block">
  @if (data().header.length > 0) {
    <div class="quest-title">
      {{ data().header }}
    </div>
  }
  <div>
    <ng-container #containerBlock></ng-container>
  </div>
</div>
}
